export const environment = {
    production: false,
    key: "oBs2gmvokGWKDTs",
    EncryptionUser: "uWkwAn0KrjrLmL6",
    Key_local:"test_xcore_ec:user_logged",
    apiBase: "https://test.xcore.ec/api/",
    wsBase: "https://test.xcore.ec",
    wsPath: "/wsio"
  };
